import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isUndefined } from 'lodash-es'
import { MessageComponent } from '.'

class Notification extends React.Component {
  componentWillReceiveProps(nextProps) {
    const { type, message } = nextProps.notification
    if (!isUndefined(type)) {
      MessageComponent.show(type, message)
    }
  }

  render() {
    return <MessageComponent />
  }
}

Notification.propTypes = {
  notification: PropTypes.shape({
    type: PropTypes.oneOf(['success', 'error', 'warning']),
    message: PropTypes.string,
  }),
}

Notification.defaultProps = {
  // TODO (v3s1e): Refactor with TS
  // eslint-disable-next-line react/default-props-match-prop-types
  type: 'warning',
  // TODO (v3s1e): Refactor with TS
  // eslint-disable-next-line react/default-props-match-prop-types
  message: '',
}

/* Component container */
const mapStateToProps = (state) => {
  return {
    notification: state.site.notification,
  }
}

const NotificationContainer = connect(mapStateToProps)(Notification)

export default NotificationContainer
